export enum BookingType {
  DirectBooking = 'directBooking',
  BookingRequest = 'bookingRequest',
}
